export const formatDateToYMD = (dateString: string): string => {
    const date = new Date(dateString);

    // Using UTC methods to avoid timezone issues
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;
};